export default "__VITE_ASSET__9ca816db__"